export default __webpack_public_path__ + "static/media/sms.7f49ee8f.svg";